// Shared definition of the Maps section pages, used by both the map shell's left
// nav and the map dashboard cards so they stay in sync.
export function buildMapItems(user, viewAs) {
  const tenant = user.tenant
  const isEffectiveAdmin = user.role === 'admin' && viewAs !== 'non-admin'
  const isTbn = (user.types && user.types[tenant]) === 'TBN'
  const telematicsType = user.telematics_types && user.telematics_types[tenant]

  const items = [
    { name: 'Fleet Map', route: 'map_fleet', icon: 'fa-map-marker',
      description: "Live map of your fleet's current vehicle locations and statuses." },
  ]
  if (isEffectiveAdmin || isTbn) {
    items.push({ name: 'Future Map', route: 'map_future', icon: 'fa-clock-o',
      description: 'Projected vehicle positions and upcoming dispatch coverage.' })
  }
  items.push({ name: 'Vehicle Trip History', route: 'map_trip_history', icon: 'fa-road',
    description: "Replay a vehicle's historical trips, stops, and geofences on the map." })
  if (telematicsType === 'SAMSARA' || isTbn) {
    items.push({ name: 'Vehicle Route History', route: 'map_route_history', icon: 'fa-location-arrow',
      description: 'Review completed vehicle routes for SAMSARA-equipped vehicles.' })
  }
  items.push({ name: 'Vehicle Booking Map', icon: 'fa-calendar', external: true,
    path: '/booking-track/' + tenant + (isTbn ? '?type=TBN' : ''),
    description: 'Map vehicles against their assigned bookings and routes.' })
  return items
}
